import { map, startsWith, values } from 'lodash';
import debug from 'debug';
import { Openapi } from './openapi.js';
import { openapiConnectionSpec } from './types.js';
import * as core from './core.js';
const log = debug('itp:core:connections');
function isOpenapiConnectionSpec(value) {
    return openapiConnectionSpec.safeParse(value).success;
}
export class Connections {
    items;
    acceptLanguage;
    constructor(acceptLanguage) {
        this.acceptLanguage = acceptLanguage;
        this.items = {};
    }
    initialize(specs) {
        log('initializing connections...');
        const visited = [], promises = map(specs, cfg => {
            if (visited.indexOf(cfg.name) > -1) {
                throw new Error(`Connection name should be unique: "${cfg.name}"`);
            }
            visited.push(cfg.name);
            if (isOpenapiConnectionSpec(cfg)) {
                return Openapi.load(cfg, this.acceptLanguage).then(o => ((this.items[cfg.name] = o), o));
            }
        });
        return Promise.all(promises).then(() => this);
    }
    get default() {
        return values(this.items)[0];
    }
    getConnection(name) {
        log('getConnection (name=%o)', name);
        if (name === 'default') {
            return this.default;
        }
        let result = this.items[name];
        if (!result) {
            throw new Error(`Connection not found. name=${name}`);
        }
        return result;
    }
    defaultArgs(args) {
        if (!args) {
            args = {};
        }
        if (!args.language) {
            args.language = this.acceptLanguage;
        }
        return args;
    }
    async request(operation, args) {
        log('request - args: %o', args);
        const cn = parseConnectionString(operation), conn = this.getConnection(cn.connection);
        return await conn.request(cn.op, this.defaultArgs(args));
    }
    async ajax(url, args) {
        return await core.request(url, this.defaultArgs(args));
    }
    urlFor(op, args) {
        const tokens = op.split('/'), connectionName = tokens.length === 1 ? 'default' : tokens[0], conn = this.getConnection(connectionName);
        let result = conn.urlFor(op, args);
        if (!startsWith(result, 'http')) {
            result = new URL(result, window.origin).toString();
        }
        log('urlFor: %s, (op=%o, args=%o)', result, op, args);
        return result;
    }
}
export function parseConnectionString(connectionString) {
    const parts = connectionString.split('/'), op = parts.pop();
    if (!op) {
        throw new Error(`Cannot parse connection string ${connectionString}`);
    }
    return {
        op,
        connection: parts.length ? parts[0] : 'default'
    };
}
//# sourceMappingURL=connections.js.map